import { useAuthContext } from '../../components/auth/AuthContext';
import { AuthEndpoint, APPLICATION_URL } from '../../common/constants';
import { getNodeEnvironment } from '../../common/nodeEnvironment';

export { ApplicationUser } from '../../components/auth/AuthContext';
export type { ApplicationUserInitProps, AuthResponse } from '../../components/auth/AuthContext';

const addParamsAndCreateFullURL = (endpoint: AuthEndpoint, searchParams: Record<string, string> = {}) => {
    const nodeEnvironment = getNodeEnvironment();
    let currentDomain;
    switch (nodeEnvironment) {
        case 'beta':
            currentDomain = APPLICATION_URL.BETA;
            break;
        case 'gamma':
            currentDomain = APPLICATION_URL.GAMMA;
            break;
        case 'prod':
            currentDomain = APPLICATION_URL.PROD;
            break;
        default:
            currentDomain = 'http://localhost:3000';
            break;
    }
    const urlWithPath = new URL(`${currentDomain}/${endpoint}`);
    Object.entries(searchParams).forEach(([key, value]) => {
        urlWithPath.searchParams.set(key, value);
    });
    urlWithPath.searchParams.set('redirect_uri', searchParams.redirect_uri ?? currentDomain);

    return urlWithPath.toString();
};

// Keep refreshToken export for backward compatibility and testing
export const refreshToken = async (): Promise<Response> => {
    const refreshTokenURL = addParamsAndCreateFullURL(AuthEndpoint.REFRESH_TOKEN);
    return fetch(refreshTokenURL, { method: 'POST' });
};

export const useAuth = () => {
    return useAuthContext();
};
